module.exports = __webpack_public_path__ + "static/TT1332_TW-MARK-M11-clean-5448a9da2c42b2fb5d241ccca43b4b7e.png";